module.exports = __webpack_public_path__ + "static/media/107410HD_Vermont_Balloons_Relaxation.8bc69316.mp4";